// ProfileLivestream.js
import { connect } from 'react-redux';

import ProfileLivestream from '../component/ProfileLivestream.jsx';

import getMeData from '../selector/getMeData.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import openUploadMenuModal from '../action/openUploadMenuModal.js';
import fetchMeLivestreams from '../action/fetchMeLivestreams.js';

const mapStateToProps = state => {
  const networkingSelectPath = ['fetch', 'me', 'livestream'];
  const nextPage = getListData(state, ['me', 'livestream'], 'nextPage');
  return {
    meId: getMeData(state, 'id'),
    nextPage,
    isNextPageFetching: getNetworkingData(
      state,
      [...networkingSelectPath, nextPage],
      'isFetching'
    ),
    isFirstPageFetched: getNetworkingData(
      state,
      [...networkingSelectPath, 1],
      'isFetched'
    ),
    livestreamSessionIds: getListData(state, ['me', 'livestream'], 'itemIds'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openUploadMenuModal: () => dispatch(openUploadMenuModal()),
    fetchMeLivestreams: ({ page: limit }) =>
      dispatch(fetchMeLivestreams({ page: limit })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileLivestream);
